import _ from 'lodash'
import constants from 'santa-renderer/src/utils/constants'

export const defaultModel = {
    measurements: {}
}

export const name = 'AnchorBaseAspect'

const getAbsoluteBoundingClientRect = boundingRect => ({
    width: boundingRect.width,
    height: boundingRect.height,
    left: boundingRect.left,
    right: boundingRect.right,
    bottom: boundingRect.bottom,
    top: boundingRect.top + (window.scrollY || window.pageYOffset)
})

const hiddenBoundingBox = {height: 0, width: 0, left: 0, right: 0, top: 0, bottom: 0}
const isHidden = boundingBox => _.isMatch(boundingBox, hiddenBoundingBox)

const measureSingleComp = compId => {
    const element = document.getElementById(compId)
    if (!element) {
        return null
    }

    const boundingBox = element.getBoundingClientRect()
    const absoluteBoundingBox = getAbsoluteBoundingClientRect(boundingBox)
    return {
        boundingBox: absoluteBoundingBox,
        isHidden: isHidden(boundingBox)
    }
}

const measureSingle = (compId, setCompMeasurements) => {
    const singleMeasurements = measureSingleComp(compId)
    setCompMeasurements(singleMeasurements)
}

const measureComponents = (getCompsToMeasureIds, setMeasurements) => () => {
    const compToMeasureIds = getCompsToMeasureIds()
    const measurements = compToMeasureIds.reduce((measurementsAcc, id) => {
        measurementsAcc[id] = measureSingleComp(id)
        return measurementsAcc
    }, {})

    measurements.screen = {
        boundingBox: {height: window.innerHeight}
    }

    setMeasurements(measurements)
}

const SCROLL_DEBOUNCE_WAIT = 100
const RESIZE_DEBOUNCE_WAIT = 16

// eslint-disable-next-line santa/no-module-state
let eventsManager = null

const registerToEvents = (getCompsToMeasureIds, setMeasurements) => {
    const measureComponentsFunction = measureComponents(getCompsToMeasureIds, setMeasurements)
    eventsManager.on('windowScroll', _.debounce(measureComponentsFunction, SCROLL_DEBOUNCE_WAIT))
    eventsManager.on(constants.EVENTS.WINDOW_RESIZE, _.debounce(measureComponentsFunction, RESIZE_DEBOUNCE_WAIT))
}

export function init(actions, {eventsManager: localEventManager}) {
    eventsManager = localEventManager
}

export const functionLibrary = {
    registerToEvents,
    measureSingle
}
